import { Box, Tab, Tabs } from "@mui/material";
import { type ReactNode } from "react";

import { PageHeader } from "~ui/atoms/PageHeader/PageHeader";

export type DataAnalyticsTabValue =
  | "candidateSearch"
  | "orgMetrics"
  | "skillsCertifications"
  | "studentCandidacy"
  | "talentAlignment"
  | "userMetrics";

export interface DataAnalyticsTab {
  label: string;
  value: DataAnalyticsTabValue;
  content: ReactNode;
}

export interface DataAnalyticsTemplateProps {
  title?: string;
  tabs: DataAnalyticsTab[];
  selectedTab: DataAnalyticsTabValue;
  onTabChange: (newValue: DataAnalyticsTabValue) => void;
}

export const DataAnalyticsTemplate = ({
  title = "Platform Insights",
  tabs,
  selectedTab,
  onTabChange,
}: DataAnalyticsTemplateProps) => {
  const handleTabChange = (_event: React.SyntheticEvent, newValue: DataAnalyticsTabValue) => {
    onTabChange(newValue);
  };

  const currentTab = tabs.find((tab) => tab.value === selectedTab);

  return (
    <Box sx={{ maxWidth: "100%", overflow: "hidden", width: "100%" }}>
      <PageHeader title={title} />
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs onChange={handleTabChange} value={selectedTab}>
          {tabs.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ maxWidth: "90%", overflow: "hidden", width: "90%" }}>{currentTab?.content}</Box>
    </Box>
  );
};
